import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { SvgIcon, RiskIndicatorBar, Loader } from '@/components';
import { RiskScoreLevelEnum } from '@/api';
import styles from './IndicatorLite.module.sass';

interface IndicatorLiteProps {
  isChecking?: boolean;
  value: RiskScoreLevelEnum | null;
  className?: string;
}

const IndicatorLite = ({
  isChecking,
  value,
  className,
}: IndicatorLiteProps) => {
  const { t } = useTranslation();
  const riskTitle = value
    ? {
        [RiskScoreLevelEnum.LOW]: t('translation.risk_explanation_level_low'),
        [RiskScoreLevelEnum.MEDIUM]: t(
          'translation.risk_explanation_level_middle',
        ),
        [RiskScoreLevelEnum.HIGH]: t('translation.risk_explanation_level_high'),
        [RiskScoreLevelEnum.UNKNOWN]: t(
          'translation.risk_explanation_level_unassigned',
        ),
      }[value]
    : '';

  const classes = cx(
    styles.risk,
    {
      [styles[`risk--${value}`]]: value && !isChecking,
      [styles['risk--checking']]: isChecking,
    },
    className,
  );

  return (
    <div className={classes}>
      <div className={styles.inner}>
        <RiskIndicatorBar risk={isChecking ? null : value} />

        {isChecking && (
          <div className={styles.loading}>
            <Loader />
            <span>{t('translation.btn_checking_state')}</span>
          </div>
        )}

        {!!value && !isChecking && (
          <div className={styles.content}>
            <div className={styles.info}>
              <SvgIcon name="info-circle" className={styles.icon} />
              <div className={styles.tooltip}>
                <div className={styles.low}>
                  <strong>{t('translation.comp_risk_label_low')}:</strong>{' '}
                  {t('translation.indicator_explanation_low')}
                </div>
                <div className={styles.medium}>
                  <strong>{t('translation.comp_risk_label_medium')}:</strong>{' '}
                  {t('translation.indicator_explanation_medium')}
                </div>
                <div className={styles.high}>
                  <strong>{t('translation.comp_risk_label_high')}:</strong>{' '}
                  {t('translation.indicator_explanation_high')}
                </div>
              </div>
            </div>
            <div className={styles.title}>{riskTitle}</div>
          </div>
        )}

        <div className={styles.from}>
          {t('translation.comp_risk_label_low')}
        </div>
        <div className={styles.to}>{t('translation.comp_risk_label_high')}</div>
      </div>
    </div>
  );
};

export default IndicatorLite;
